/**
 * PersistenceServiceStandalone — STUB pending M4.
 *
 * Full impl wraps wa-sqlite (or sql.js) backed by IndexedDB VFS for
 * true persistence across page reloads. wa-sqlite is the recommended
 * choice per planner §M3 risk table (sql.js loses state without manual
 * serialization). M4 ships the WASM + the IndexedDB VFS hookup.
 *
 * Until M4: every method throws ServiceUnavailableError so the SPA's
 * campaign-picker (when it exists at A2+) surfaces an "install
 * vibe-designer or use the in-browser persistence preview at M4"
 * degradation banner. isAvailable returns false.
 */
import type {
  CampaignHandle,
  CampaignMeta,
  PersistenceService,
} from '../types';
import { ServiceUnavailableError } from '../types';

const REASON = 'standalone_wa_sqlite_not_yet_implemented';

export class PersistenceServiceStandalone implements PersistenceService {
  isAvailable(): boolean {
    return false;
  }

  async openCampaign(_id: string): Promise<CampaignHandle> {
    throw new ServiceUnavailableError(
      'PersistenceServiceStandalone.openCampaign',
      REASON,
    );
  }

  async listCampaigns(): Promise<CampaignMeta[]> {
    throw new ServiceUnavailableError(
      'PersistenceServiceStandalone.listCampaigns',
      REASON,
    );
  }

  async createCampaign(_name: string, _moduleId: string): Promise<CampaignMeta> {
    throw new ServiceUnavailableError(
      'PersistenceServiceStandalone.createCampaign',
      REASON,
    );
  }

  async deleteCampaign(_id: string): Promise<void> {
    throw new ServiceUnavailableError(
      'PersistenceServiceStandalone.deleteCampaign',
      REASON,
    );
  }
}
